var _g, _g2, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinLegend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_776_6810)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21.9905,
    cy: 22.5003,
    r: 21.9905,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_776_6810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1234 13.5711V9.68614H24.9244V11.592L21.9923 8.95312L14.6621 15.5503H16.8612V21.4144H20.5263V17.0163H23.4583V21.4144H27.1234V15.5503H29.3225L27.1234 13.5711Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6451 29.4988C18.2784 29.4988 18.5819 29.7495 18.5819 30.2641V30.3697C18.5819 30.9766 18.318 31.2405 17.3944 31.6495L16.827 31.9002C15.3361 32.5599 14.7819 33.3912 14.7819 35.1064V35.9509C14.7819 36.2543 14.8743 36.3467 15.2305 36.3467H20.3235C20.6929 36.3467 20.7721 36.2279 20.7721 35.9509V35.08C20.7721 34.737 20.7193 34.6446 20.3235 34.6446H16.8666V34.4995C16.8666 33.9585 17.1041 33.7474 18.3576 33.1405L19.0437 32.8106C20.218 32.2432 20.8117 31.5571 20.8117 30.1585V30.0002C20.8117 28.4037 19.7693 27.6912 18.0805 27.6912H18.0409C17.0777 27.6912 16.0617 27.9023 15.3361 28.2058C15.0986 28.2981 15.059 28.4433 15.1249 28.694L15.3624 29.644C15.4152 29.8551 15.534 29.921 15.7715 29.8419C16.3916 29.6308 17.0777 29.4988 17.5923 29.4988H17.6451ZM23.9002 32.8634L25.7342 29.8947H25.7474V32.8634H23.9002ZM28.571 34.5259C28.9008 34.5259 28.9404 34.4599 28.9404 34.1696V33.2196C28.9404 32.9294 28.9008 32.8634 28.571 32.8634H27.8849V28.3641C27.8849 27.9155 27.7925 27.81 27.3439 27.81H25.7474C25.378 27.81 25.2328 27.8759 25.0085 28.2322L22.2509 32.6787C21.987 33.1009 21.9474 33.2328 21.9474 33.7738V34.0905C21.9474 34.4467 22.0266 34.5259 22.3829 34.5259H25.7474V35.9113C25.7474 36.3203 25.8661 36.3467 26.2488 36.3467H27.4099C27.7793 36.3467 27.8849 36.3203 27.8849 35.9113V34.5259H28.571Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_776_6810",
    x: 0,
    y: 0.509766,
    width: 43.9805,
    height: 43.9814,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.09953
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.909804 0 0 0 0 0.909804 0 0 0 0 0.909804 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_776_6810"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_776_6810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5924,
    height: 17.5924,
    fill: "white",
    transform: "translate(13.1934 6.75391)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinLegend);
export default __webpack_public_path__ + "static/media/pin_legend.41de99d39a0d4a5c1b0175f106aec66c.svg";
export { ForwardRef as ReactComponent };